import React from 'react';

import { useLanguage } from '~/Hooks';
import { FilterRadioButtonList } from '~/Components/Filter';
import { FilterType } from '~/Hooks/useFilter';
import { useProviderFilters } from '~/Hooks/useFilter/useProviderFilters';
import { useSelectedItem } from '../useSelectedItem';

export interface IUseEventCategoriesGroupFilterProps {
  filterType: FilterType;
  initialFilter?: string[];
}

export const useEventStatusFilter = ({
  filterType,
  initialFilter = ['true'],
}: IUseEventCategoriesGroupFilterProps) => {
  const { appliedFilters } = useProviderFilters({ filterType });

  const { public: initialState = initialFilter } = appliedFilters;
  const { t } = useLanguage();

  const list = [
    {
      value: 'true',
      label: t('form.field.public'),
    },
    {
      value: 'false',
      label: t('form.field.private'),
    },
    {
      value: '',
      label: t('app.eventGroups.tab.all'),
    },
  ];

  const {
    selectItem,
    onClearMap,
    onApplyMap,
    selectedItem,
    selectedCount,
    updateSelectedMap,
    appliedSelectionIds,
  } = useSelectedItem({ initialState });

  return {
    name: 'public',
    title: t('form.title.status'),
    elements: (
      <FilterRadioButtonList list={list} selectItem={selectItem} selectedItem={selectedItem} />
    ),
    onClearMap,
    onApplyMap,
    selectedCount,
    updateSelectedMap,
    appliedSelectionIds,
  };
};
